var _path, _path2, _path3, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlagDeutchinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 9H1V2.333C1 1.597 1.597 1 2.333 1h29.334C32.403 1 33 1.597 33 2.333V9z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 9H1v8h32V9z",
    fill: "#E00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 23.667c0 .736-.597 1.333-1.333 1.333H2.333A1.333 1.333 0 011 23.667V17h32v6.667z",
    fill: "#FDCF00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 25,
    rx: 2.5,
    stroke: "#8F8FA3"
  })));
}

export default SvgFlagDeutchinline;